import { render, staticRenderFns } from "./important-notice.vue?vue&type=template&id=3ed80fa8&"
import script from "./important-notice.vue?vue&type=script&lang=js&"
export * from "./important-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports